<div style="padding: .25em; display: inline; white-space: nowrap">
  <svg
    (click)="closeClicked($event)"
    style="width: 1.2em; cursor: pointer"
    aria-hidden="true"
    focusable="false"
    role="img"
    viewBox="0 0 64 64"
    id="svg19"
    xmlns="http://www.w3.org/2000/svg">
    <defs id="defs23"/>
    <path
      fill="currentColor"
      d="m 32.271186,1.2711864 c -17.125,0 -30.9999996,13.8749996 -30.9999996,30.9999996 0,17.125 13.8749996,31 30.9999996,31 17.125,0 31,-13.875 31,-31 0,-17.125 -13.875,-30.9999996 -31,-30.9999996 z m 15.2,39.1374996 c 0.5875,0.5875 0.5875,1.5375 0,2.125 l -4.95,4.9375 c -0.5875,0.5875 -1.5375,0.5875 -2.125,0 l -8.125,-8.2 -8.1375,8.2 c -0.5875,0.5875 -1.5375,0.5875 -2.125,0 l -4.9375,-4.95 c -0.5875,-0.5875 -0.5875,-1.5375 0,-2.125 l 8.2,-8.125 -8.2,-8.1375 c -0.5875,-0.5875 -0.5875,-1.5375 0,-2.125 l 4.95,-4.95 c 0.5875,-0.5875 1.5375,-0.5875 2.125,0 l 8.125,8.2125 8.1375,-8.2 c 0.5875,-0.5875 1.5375,-0.5875 2.125,0 l 4.95,4.95 c 0.5875,0.5875 0.5875,1.5375 0,2.125 l -8.2125,8.125 z"
      id="path17"
      style="stroke-width:0.125"/>
  </svg>
  <span style="margin-left: 3px; font-size: 1.5em">{{ item.value }}</span>
</div>
